import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a8be922755b8c0014d81459_1787914778501_e038f74a/luztraining/src/app/not-found.tsx");
